module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (productIDEntered) { ;
__p += '\n<fieldset>\n    <div>Show:</div>\n    <div class="toggle-image-region">\n    <div class="toggle-price-region">\n    <div class="toggle-title-region">\n    <div class="toggle-description-region">\n    </div>\n</fieldset>\n';
 } ;
__p += '\n\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/dynamicProductWidget/ShowWidgetsView.tpl
// module id = 2091
// module chunks = 0